import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FadeInSection from '@/components/base/FadeInSection';
import OutcomesSection from '@/pages/home/components/OutcomesSection';
import SuccessStoriesSection from '@/pages/home/components/SuccessStoriesSection';

export default function Outcomes() {
  return (
    <main>
      <Navbar />
      <div className="pt-14">
        <FadeInSection>
          <OutcomesSection />
        </FadeInSection>
        <FadeInSection>
          <SuccessStoriesSection />
        </FadeInSection>
      </div>
      <Footer />
    </main>
  );
}